var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.21967 9.79079C-0.0732233 9.51184 -0.0732233 9.05958 0.21967 8.78064L4.18934 5L0.21967 1.21936C-0.0732229 0.940416 -0.0732229 0.488155 0.21967 0.209209C0.512564 -0.0697374 0.987437 -0.0697374 1.28033 0.209209L5.78033 4.49492C6.07322 4.77387 6.07322 5.22613 5.78033 5.50508L1.28033 9.79079C0.987437 10.0697 0.512563 10.0697 0.21967 9.79079Z",
    fill: "#00A287"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrowRight);
export default __webpack_public_path__ + "static/media/green-arrow-right.fdbb03e78dbec3edf648b85485933574.svg";
export { ForwardRef as ReactComponent };